(function(){'use strict';const shopRoot=document.getElementById('shappy-shop');if(!shopRoot||shopRoot.dataset.initialized)return;shopRoot.dataset.initialized='true';const shopConfig=JSON.parse(shopRoot.querySelector('[data-shop-config]').textContent),shopData=JSON.parse(shopRoot.querySelector('[data-shop-products]').textContent),shopScope={};
shopData.swatches=shopData.shappySwatchStyles || {};
// Liquid's translation filter can return escaped entities. Decode once for textContent.
const translationDecoder=document.createElement('textarea');
Object.keys(shopConfig.strings).forEach(key=>{translationDecoder.innerHTML=shopConfig.strings[key];shopConfig.strings[key]=translationDecoder.value;});
function contextualUrl(url){const base=shopConfig.root;const local=new URL(url,location.origin);if(local.origin!==location.origin)return local.href;const prefix=base.replace(/\/$/,'');if(!prefix || local.pathname===prefix || local.pathname.startsWith(prefix+'/'))return local.pathname;return base+local.pathname.replace(/^\//,'');}
function shopEsc(s){return String(s==null?'':s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));}
// compareAt is only set when the market catalogue actually reduces that variant.
function shopPriceInto(el,v,prefix){if(!el)return;const now=shopEsc((prefix||'')+v.formattedPrice);el.innerHTML=v.formattedCompareAt?now+' <s class="was">'+shopEsc(v.formattedCompareAt)+'</s>':now;}
const byHandle=new Map(shopData.products.map(p=>[p.handle,p]));
shopRoot.querySelectorAll('a[href]').forEach(a=>{const u=new URL(a.getAttribute('href'),location.origin),handle=u.pathname.split('/products/')[1];if(handle){const p=byHandle.get(handle);if(p){const v=p.variants.find(v=>v.available)||p.variants[0];a.href=contextualUrl(p.url)+'?variant='+v.id;}}});
shopRoot.querySelectorAll('[data-shop-handle]').forEach(a=>{const p=byHandle.get(a.dataset.shopHandle);if(!p){a.hidden=true;return;}const v=p.variants.filter(v=>v.available).sort((a,b)=>a.price-b.price)[0]||p.variants[0];shopPriceInto(a.querySelector('[data-market-price]'),v,(p.variants.some(x=>x.price!==v.price)?shopConfig.strings.From+' ':''));});
shopRoot.querySelectorAll('[data-shop-handles]').forEach(card=>{const models=card.dataset.shopHandles.split(',').map(h=>byHandle.get(h)).filter(Boolean);if(!models.length){card.hidden=true;return;}const variants=models.flatMap(p=>p.variants);const available=variants.filter(v=>v.available);const v=(available.length?available:variants).sort((a,b)=>a.price-b.price)[0];const price=card.querySelector('[data-market-price]');if(price)shopPriceInto(price,v,(variants.some(x=>x.price!==v.price)?shopConfig.strings.From+' ':''));});

(function (scope) {
  'use strict';
  const esc = value => String(value).replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll("'", '&#39;');
  const discountBadge = v => (v.compareAt && v.compareAt > v.price)
    ? '<span class="catalog-badge">-' + Math.round((1 - v.price / v.compareAt) * 100) + '%</span>'
    : '';
  const priceMarkup = v => esc(v.formattedPrice) + (v.formattedCompareAt
    ? ' <s class="was">' + esc(v.formattedCompareAt) + '</s>' + discountBadge(v)
    : '');
  const imageUrl = (url, width) => url + (url.includes('?') ? '&' : '?') + 'width=' + width;
  const config = shopConfig || { locale: 'en-IE', prefix: '', strings: {} };
  const t = (source, values = {}) => {
    let translated = config.strings[source] || source;
    for (const [key, value] of Object.entries(values)) translated = translated.replaceAll('{' + key + '}', String(value));
    return translated;
  };
  const money = value => new Intl.NumberFormat(config.locale, { style: 'currency', currency: shopConfig.currency || 'EUR' }).format(Number(value));
  const initialVariant = product => product.variants.find(v => v.available) || product.variants[0];
  const variantUrl = (product, variant) => contextualUrl(product.url) + '?variant=' + variant.id;
  function selectedVariant(product, selected) {
    return product.variants.find(v => String(v.id) === String(selected[product.handle])) || initialVariant(product);
  }
  function swatchStyle(variant, swatches) {
    const name = variant.title.split(' / ').at(-1);
    if (swatches[name]) return swatches[name].replaceAll('url(//', 'url(https://');
    for (const first of Object.keys(swatches).sort((a, b) => b.length - a.length)) {
      const second = name.slice(first.length + 1);
      if (name.startsWith(first + ' ') && swatches[second]) {
        const colour = key => swatches[key].match(/background-color:([^;]+)/)[1];
        return 'background:linear-gradient(90deg,' + colour(first) + ' 50%,' + colour(second) + ' 50%)';
      }
    }
    // A real variant thumbnail is safer than inventing a colour for an unknown name.
    return 'background:#fff url(' + imageUrl(variant.image, 80) + ') center/cover';
  }
  function swatchesMarkup(product, variant, expanded, visibleLimit, swatches) {
    const variants = [variant, ...product.variants.filter(v => v.id !== variant.id)];
    const groupId = 'colours-' + product.handle;
    const buttons = variants.map((v, index) => '<button type="button" class="catalog-swatch' + (v.available ? '' : ' is-unavailable') + '" data-variant="' + v.id + '" aria-pressed="' + (v.id === variant.id) + '" aria-label="' + esc(v.title + (v.available ? '' : ' · ' + t('Sold out'))) + '" title="' + esc(v.title + (v.available ? '' : ' · ' + t('Sold out'))) + '"' + (index >= visibleLimit && !expanded ? ' hidden' : '') + '><span style="' + esc(swatchStyle(v, swatches)) + '"></span></button>').join('');
    const toggle = variants.length > visibleLimit ? '<button type="button" class="swatch-more" aria-controls="' + groupId + '" aria-expanded="' + expanded + '" aria-label="' + esc(expanded ? t('Show fewer colours') : t('Show all {count} colours', {count: variants.length})) + '">' + (expanded ? '−' : '+' + (variants.length - visibleLimit)) + '</button>' : '';
    return '<div id="' + groupId + '" class="catalog-swatches" role="group" aria-label="' + esc(t('Colours for {product}', {product: product.title})) + '">' + buttons + toggle + '</div>';
  }
  function cardMarkup(product, state, visibleLimit, swatches) {
    const variant = selectedVariant(product, state.selected);
    const href = esc(variantUrl(product, variant));
    const srcset = [320, 640, 960].map(w => esc(imageUrl(variant.image, w)) + ' ' + w + 'w').join(', ');
    return '<article class="catalog-card" data-product="' + esc(product.handle) + '"><a class="catalog-photo" href="' + href + '"><img src="' + esc(imageUrl(variant.image, 640)) + '" srcset="' + srcset + '" sizes="(max-width:650px) calc((100vw - 40px)/2), (max-width:900px) 30vw, 285px" loading="lazy" decoding="async" width="640" height="440" alt="' + esc(product.title + ' - ' + variant.title) + '"></a><h3><a class="catalog-title" href="' + href + '">' + esc(product.title) + '</a></h3><p class="catalog-price">' + priceMarkup(variant) + '</p><div class="catalog-colour-controls">' + swatchesMarkup(product, variant, state.expanded.has(product.handle), visibleLimit, swatches) + '</div><p class="catalog-colour" aria-live="polite">' + esc(variant.title) + '</p><p class="catalog-stock" aria-live="polite">' + (variant.available ? '' : t('Sold out')) + '</p><a class="cta" href="' + href + '">' + esc(t('View product')) + ' <span aria-hidden="true">↗</span></a></article>';
  }
  function createState() { return { category: 'all', limit: 12, selected: {}, expanded: new Set() }; }
  const matching = (products, category) => products.filter(p => category === 'all' || p.category === category);
  const api = { t, esc, imageUrl, money, initialVariant, selectedVariant, variantUrl, swatchesMarkup, cardMarkup, createState, matching };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else scope.ShappyCatalog = api;
})(shopScope);

(function () {
  'use strict';
  const root = shopRoot.querySelector('.catalog');
  const data = shopData;
  const core = shopScope.ShappyCatalog;
  if (!root || !data || !core) return;
  const state = core.createState();
  const grid = root.querySelector('.catalog-grid');
  const more = root.querySelector('.catalog-more');
  const counter = root.querySelector('#catalog-count');
  const mobile = window.matchMedia('(max-width:650px)');
  const visibleLimit = () => mobile.matches ? 2 : 3;
  const productByHandle = new Map(data.products.map(p => [p.handle, p]));

  function updateCount(items) {
    counter.textContent = core.t('Showing {shown} of {total} products', {shown: Math.min(state.limit, items.length), total: items.length});
    more.hidden = state.limit >= items.length;
  }
  function renderFiltered() {
    const items = core.matching(data.products, state.category);
    grid.innerHTML = items.slice(0, state.limit).map(p => core.cardMarkup(p, state, visibleLimit(), data.swatches)).join('');
    updateCount(items);
  }
  root.querySelectorAll('[data-category]').forEach(button => {
    button.addEventListener('click', () => {
      state.category = button.dataset.category;
      state.limit = 12;
      root.querySelectorAll('[data-category]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      renderFiltered();
    });
  });
  more.addEventListener('click', () => {
    const items = core.matching(data.products, state.category);
    const before = grid.children.length;
    state.limit += 12;
    // Append only: previous cards, selected colours and expanded swatches stay intact.
    grid.insertAdjacentHTML('beforeend', items.slice(before, state.limit).map(p => core.cardMarkup(p, state, visibleLimit(), data.swatches)).join(''));
    updateCount(items);
    grid.children[before]?.querySelector('a')?.focus({ preventScroll: true });
  });

  function renderSwatches(card, product, focusSelector) {
    const variant = core.selectedVariant(product, state.selected);
    card.querySelector('.catalog-colour-controls').innerHTML = core.swatchesMarkup(product, variant, state.expanded.has(product.handle), visibleLimit(), data.swatches);
    if (focusSelector) card.querySelector(focusSelector)?.focus({ preventScroll: true });
  }
  grid.addEventListener('click', event => {
    const button = event.target.closest('button');
    const card = button?.closest('[data-product]');
    if (!card) return;
    const product = productByHandle.get(card.dataset.product);
    if (button.classList.contains('swatch-more')) {
      if (state.expanded.has(product.handle)) state.expanded.delete(product.handle);
      else state.expanded.add(product.handle);
      renderSwatches(card, product, '.swatch-more');
      return;
    }
    const variant = product.variants.find(v => String(v.id) === button.dataset.variant);
    if (!variant) return;
    state.selected[product.handle] = variant.id;
    card.querySelectorAll('a').forEach(a => { a.href = core.variantUrl(product, variant); });
    const image = card.querySelector('.catalog-photo img');
    image.srcset = [320, 640, 960].map(w => core.imageUrl(variant.image, w) + ' ' + w + 'w').join(', ');
    image.src = core.imageUrl(variant.image, 640);
    image.alt = product.title + ' - ' + variant.title;
    card.querySelector('.catalog-price').innerHTML = priceMarkup(variant);
    card.querySelector('.catalog-colour').textContent = variant.title;
    card.querySelector('.catalog-stock').textContent = variant.available ? '' : core.t('Sold out');
    // The active colour always returns to the first position, even after collapsing.
    renderSwatches(card, product, '[data-variant="' + variant.id + '"]');
  });
  mobile.addEventListener('change', () => {
    const active = document.activeElement;
    grid.querySelectorAll('[data-product]').forEach(card => {
      const focused = card.contains(active) && active?.dataset.variant ? '[data-variant="' + active.dataset.variant + '"]' : null;
      renderSwatches(card, productByHandle.get(card.dataset.product), focused);
    });
  });
  renderFiltered();

  const openerByDialog = new WeakMap();
  shopRoot.querySelectorAll('[data-open]').forEach(button => button.addEventListener('click', () => {
    const dialog = shopRoot.querySelector("#" + 'dialog-' + button.dataset.open);
    if (!dialog) return;
    openerByDialog.set(dialog, button);
    dialog.showModal();
    dialog.querySelector('.close').focus();
  }));
  shopRoot.querySelectorAll('dialog').forEach(dialog => {
    dialog.querySelector('.close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => openerByDialog.get(dialog)?.focus({ preventScroll: true }));
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
    });
  });

  const navLinks = [...shopRoot.querySelectorAll('.quick a')];
  const sections = [...shopRoot.querySelectorAll('.family, #all-products')];
  let scheduled = false;
  function highlightNavigation() {
    const sticky = shopRoot.querySelector('.nav-shell');
    const threshold = sticky.getBoundingClientRect().height + 28;
    let active = sections[0];
    for (const section of sections) if (section.getBoundingClientRect().top <= threshold) active = section;
    navLinks.forEach(link => {
      if (link.hash === '#' + active.id) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
    scheduled = false;
  }
  window.addEventListener('scroll', () => {
    if (!scheduled) { scheduled = true; window.requestAnimationFrame(highlightNavigation); }
  }, { passive: true });
  window.addEventListener('resize', highlightNavigation);
  highlightNavigation();
})();

})();
